import * as React from "react";
import Box from "@mui/material/Box";
import "@fontsource/lato";
import "@fontsource/montserrat";
import { Theme, NaviStyle } from "../styles/styles";
import { ThemeProvider } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { StatusBox } from "./StatusBox";
import { Button } from "@mui/material";
import { IconMenu } from "./IconMenu";
import './GoodListItemAdmin.css';

export const GoodListItemAdmin = (
    {
        epid,
        goodName,
        date,
        location,
        goodPionts,
        status,
        clickaccept,
        onClickReject,
        onClickEdit,
        onClickHistory,
        onClickPreview,
        rejectDisabled = false,
        itemList,
    }
) => {

    const epidBox = () => {
        return (
            <Box className="epid-box">
                <Typography variant="bodyMediumRegural">EPID</Typography>
                <Typography variant="bodyMediumBlack">{epid || '?'}</Typography>
            </Box>
        )
    }

    const goodDescriptionBox = () => {
        return (
            <Box className='good-description-box'>
                <Box className='content-box'>
                    <Typography variant="bodyMediumRegural">Dobro</Typography>
                    <Typography variant="bodyMediumBlack">{goodName}</Typography>
                </Box>
            </Box>

        )
    }

    const newGoodBox = () => {
        return (
            <Box className={'new-good-box'}
                sx={{
                    width: status === "Oczekuje na weryfikację" ? "5%" : 0,
                }}
            >
                {status === "Oczekuje na weryfikację" && (
                    <Box className='content-box'>
                        <Typography variant="bodyMediumRegural" fontWeight="bold">
                            Nowy
                        </Typography>
                    </Box>
                )}
            </Box>
        )
    }

    const dataBox = () => {
        return (
            <Box className='data-box'>
                <Typography variant="bodyMediumRegural">Data</Typography>
                <Typography variant="bodyMediumBlack">{date}</Typography>
            </Box>
        )
    }

    const localizationBox = () => {
        return (
            <Box className='localization-box'>
                <Typography variant="bodyMediumRegural" noWrap>
                    Lokalizacja
                </Typography>
                <Typography variant="bodyMediumBlack">
                    {location}
                </Typography>
            </Box>

        )
    }

    const punktyBox = () => {
        return (
            <Box className='punkty-box'>
                <Typography variant="bodyMediumRegural">Pkt</Typography>
                <Typography variant="bodyMediumBlack">{goodPionts}</Typography>
            </Box>
        )
    }

    const statusBox = () => {
        return (
            <Box className='status-box'>
                <Typography variant="bodyMediumRegural">Status</Typography>
                <Box className='content-box'>
                    <StatusBox statusMessage={status}/>
                </Box>
            </Box>
        )
    }

    const acceptationChoice = () => {
        return (
            <Box className='btn-box'>
                <Box className='acceptation-choice'>
                    <Button
                        onClick={() => {
                            clickaccept();
                        }}
                        sx={Theme.outlinedAcceptButton}
                    >
                        Akceptuj
                    </Button>

                    <Button
                        onClick={onClickReject}
                        disabled={rejectDisabled}
                        sx={Theme.outlinedCancelButton}
                    >
                        Odrzuć
                    </Button>
                </Box>
            </Box>
        )
    }

    const buttonMenu = () => {
        return (
            <Box className='btn-box'>
                <Box className='button-menu'>
                    <IconMenu
                        onClickHistory={onClickHistory}
                        optionSelected={onClickEdit}
                        list={itemList}
                        onClickPreview={() => {
                            onClickPreview();
                        }}
                    />
                </Box>
            </Box>

        )
    }

    const buttonsBox = () => {
        if (status.match(/Oczekuje na weryf/) || status.match(/W trakcie weryf/)) {
            return acceptationChoice();
        } else {
            return buttonMenu();
        }
    }

    return (
        <Box className='good-list-item-row'>
            <ThemeProvider theme={Theme}>

                {epidBox()}
                {goodDescriptionBox()}
                {newGoodBox()}
                {dataBox()}

                <Box className='flex-box'>

                    {localizationBox()}
                    {punktyBox()}
                    {statusBox()}
                    {buttonsBox()}

                </Box>
            </ThemeProvider>
        </Box>
    );
};
